import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-global-supplier-abn-config',
  standalone: false,
  templateUrl: './global-supplier-abn-config.component.html'
})
export class GlobalSupplierAbnConfigComponent implements OnInit {
  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'global-supplier-abn',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'globalSupplierAbnId', header: 'Supplier Abn ID', type: ColumnType.String, isReadonly: true, isPrimary: true, notInForm: true  },
        { field: 'globalAbnId', header: 'Global Abn', type: ColumnType.MultiSelectComplex, setUrl: 'global-abn/lookup' },
        { field: 'keyword', header: 'Keyword', type: ColumnType.String, addFormDefault: '' },
        { field: 'globalSupplierId', header: 'Global Supplier', type: ColumnType.MultiSelectComplex, setUrl: 'global-supplier/lookup' },
        { field: 'ezeTemplateName', header: 'Eze Template Name', type: ColumnType.String, addFormDefault: '' }
      ],
      addFormConfig: {
        header: 'Add Global Supplier Abn'
      },
      isConfigurable: true
    };
  }}
